import { createStore } from "vuex";
import persistedStateVuex from "persisted-state-vuex";

export default createStore({
  state: {
    userLogged: "",
    userControlNumber: "",
    userProfilePhoto: "",
    userVideoCallURL: "",
    userEmail: "",
    userMembershipStatus: "",
    userBenefitEligible:"",

    getPatientDoctorId: null
  },
  mutations: {
    setUserLogged(state, value) {
      state.userLogged = value.userLogIn;
      state.userControlNumber = value.controlnumber;
      state.userProfilePhoto = value.profile;
      state.userEmail = value.email
      state.userContact = value.contactnumber
      state.userMemberSince= value.membersince
    },
    clearUser(state) {
      state.userLogged = "";
      state.userProfilePhoto = "";
    },
  },
  plugins: [persistedStateVuex.init],
});
